import { Component, OnInit, Renderer2 } from '@angular/core';
import { ConfigService } from './services/config.service';
import { CORE_IMPORTS } from './providers/module-providers';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  styleUrls: ['./app.component.css'],
  imports: [CORE_IMPORTS, RouterOutlet]
})

export class AppComponent implements OnInit {
  title = 'business';
  temaPadrao: string

  constructor(
    private configService: ConfigService,
    private renderer: Renderer2
  ){ }

  ngOnInit(): void {
    this.temaPadrao = this.configService.temaPadrao;
    this.renderer.addClass(document.body, this.temaPadrao);
  }
}
